import { render, staticRenderFns } from "./StudentStar.vue?vue&type=template&id=6799bce3&scoped=true"
import script from "./StudentStar.vue?vue&type=script&lang=js"
export * from "./StudentStar.vue?vue&type=script&lang=js"
import style0 from "./StudentStar.vue?vue&type=style&index=0&id=6799bce3&prod&scoped=true&lang=css"
import style1 from "./StudentStar.vue?vue&type=style&index=1&id=6799bce3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6799bce3",
  null
  
)

export default component.exports